import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';

export async function deleteGroup(groupId: string): Promise<void> {
  await db.deleteDoc(db.doc(firestore, 'groups', groupId));
}
